export const ACCOUNT_MODE_MODAL_OPEN = "ACCOUNT_MODE_MODAL/MAYBE_OPEN";
export const ACCOUNT_MODE_MODAL_CLOSE = "ACCOUNT_MODE_MODAL/CLOSE";
export const ACCOUNT_MODE_MODAL_RESET = "ACCOUNT_MODE_MODAL/RESET";
export const ACCOUNT_MODE_MODAL_CHOOSE_GUEST = "ACCOUNT_MODE_MODAL_CHOOSE_GUEST";

